<div class="main">
    <div class="section">
      <div class="header">
        {{'EDIT_VEHICLE.title' | translate}}
        <i class="material-icons" (click)="closeDialog();">clear</i>
      </div>
      <div class="addSection">
        <div class="form">
  
          <div class="formElement">
            <div class="formLabel">
              {{'EDIT_VEHICLE.vehNumber' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              <small class="smallLink" *ngIf="showVerifyLinks" (click)="openVerifyModal('https://vahan.nic.in/nrservices/faces/user/searchstatus.xhtml')">({{'ADD_VEHICLE.verifyRC' | translate}})</small>

            </div>
            <div class="formInput">
              <input class="form-input" [(ngModel)]="vehicleData.registrationNumber" type="text" [placeholder]="vehicle_pattern"/>
            </div>
          </div>
  
          <div class="formElement">
            <div class="formLabel">
              {{'EDIT_VEHICLE.truckType' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
            </div>
            <div class="formInput">
  
              <input class="form-input" [matAutocomplete]="auto" [(ngModel)]="type" type="text" />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let type of vehicletypes" [value]="type" (click)="selectVehicleType(type)">
                  <span>{{type.name}}</span>
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="formElement">
            <div class="formLabel">
              {{'ADD_VEHICLE.actualCapacity' | translate}}
              <small class="smallLink" >({{'ADD_VEHICLE.tonage' | translate}})</small>
            </div>
            <div class="formInput">
              <input class="form-input" [(ngModel)]="vehicleData.actual_capacity" type="text" />
            </div>
          </div>
  
          <div class="formElement">
            <div class="formLabel">
              {{'EDIT_VEHICLE.chassisNum' | translate}}
            </div>
            <div class="formInput">
              <input class="form-input" [(ngModel)]="vehicleData.chassisNumber" type="text"/>
            </div>
          </div>
  
          <div class="formElement">
            <div class="formLabel">
              {{'EDIT_VEHICLE.engineName' | translate}}
            </div>
            <div class="formInput">
              <input class="form-input" [(ngModel)]="vehicleData.engineNumber" />
            </div>
          </div>
  
          <div class="formElement">
            <div class="formLabel">
              {{'EDIT_VEHICLE.regYear' | translate}}
            </div>
            <div class="formInput">
              <input class="form-input" [(ngModel)]="vehicleData.registrationYear" type="number" onkeypress="return event.charCode >= 48" [min]="minYear"/>
            </div>
          </div>
  
          <div class="formElement">
            <div class="formLabel">
              {{'EDIT_VEHICLE.transporter' | translate}}
            </div>
            <div class="formInput">
              <input class="form-input" type="text" /> <!-- [(ngModel)]="newVehicleData.transporter"-->
            </div>
          </div>
  
          <div class="formElement">
            <div class="formLabel">
              {{'EDIT_VEHICLE.mileage' | translate}} ({{vehicleData.mileageUnit}})
            </div>
            <div class="formInput">
              <input class="form-input" [(ngModel)]="vehicleData.mileage" type="number" onkeypress="return event.charCode >= 48" min="0"/>
            </div>
          </div>
  
          <div class="formElement">
            <div class="formLabel">
              {{'EDIT_VEHICLE.tankSize' | translate}} ({{vehicleData.tankCapacityUnit}})
            </div>
            <div class="formInput">
              <input class="form-input" [(ngModel)]="vehicleData.tankCapacity" type="number" onkeypress="return event.charCode >= 48" min="0"/>
            </div>
          </div>
          
          <div class="formElement">
            <div class="formLabel">
              {{'EDIT_VEHICLE.gps_provider' | translate}}
            </div>
            <mat-select class="inputSelect" style="color: #fff;" [(ngModel)]="selectedGPSProvider">
              <mat-option *ngFor="let provider of gps_providers" [value]="provider" (click)="selectGPSProvider(provider)">
                {{provider.name}}
              </mat-option>
          </mat-select>
          </div>
          <div style="display:inline-flex;" *ngIf="spinner">
            <span >
              <mat-spinner [diameter]="20" style="position: relative;top: 30px;"></mat-spinner>
            </span>
          </div>
          <div class="formElement" *ngIf="showGPSProvider && assetsArray && assetsArray.length" >
            <div class="formLabel">
              {{'EDIT_VEHICLE.asset' | translate}}
            </div>
            <div class="formInput">
              <input class="form-input" type="text" (keyup)="applyFilter($event.target.value)" [matAutocomplete]="auto_assets" [(ngModel)]="selectedAsset">
              <mat-autocomplete #auto_assets="matAutocomplete">
              <mat-option *ngFor="let asset of assets" [value]="asset.reg_number" (click)="selectAsset(asset)" >
                  {{asset.reg_number}}
              </mat-option>
            </mat-autocomplete>
            </div>
          </div>
          <div class="submitButton" (click)="submit();">
            <div class="button">{{'EDIT_VEHICLE.submitButton' | translate}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  